import DeleteIcon from '../../../assets/icons/delete.svg?react';

const SmsContactItem = ({ contact, onDelete }) => {
  return (
    <tr>
      <td className="contact-name">{contact?.Name || '-'}</td>
      <td className="contact-phone">{contact?.PhoneNumber || '-'}</td>
      <td className="contact-organization">{contact?.Organization || '-'}</td>
      <td>
        <div className="flex gap-5 justify-end">
          <button 
            className="btn icon-btn" 
            onClick={(e) => {e.stopPropagation(); onDelete(contact)}}
          >
            <DeleteIcon color='var(--red-500)'/>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default SmsContactItem;
